import { useAppDispatch, useAppTranslation } from 'app/hooks';
import FooterMenu from 'components/Commons/FooterMenu';
import Header from 'components/Commons/Header';
import ChangePasswordPage from 'features/auth/pages/ChangePasswordPage';
import useUserDetail from 'hooks/useUserDetail';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { onChangeAuthPage, setShowSubMenu } from '../homeSlice';
import AuthPage from 'features/auth/pages/AuthPage';
import TransactionModal from '../components/Modals/TransactionModal';
import { IMG_ALT } from 'consts/app';
import tiktok_bg from 'assets/images/tiktok_live_bg.png';
import { TwitchPlayer } from 'react-twitch-embed';
import { useLocation, useSearchParams } from 'react-router-dom';
import streamApi from 'api/streamApi';
import { RewardSettingResponse, StreamResponse } from 'models/stream';
import useThemes from 'hooks/useThemes';
import { showSuccessModal } from 'components/Modals/CommonModals';

interface StreamingProps {}

const YOUTUBE_URL = 'https://www.youtube.com/live/';
const TWITCH_URL = 'https://www.twitch.tv/';

const SECOND_ON_MINUTE = 60;

const Streaming: React.FunctionComponent<StreamingProps> = (props) => {
  const t = useAppTranslation();
  const [isShowChangePasswordForm, setIsShowChangePasswordForm] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { isUserLoggedIn, currentUser } = useUserDetail();
  const [searchParams, setSearchParams] = useSearchParams();
  const [streamChanels, setStreamChanels] = useState<StreamResponse[] | null>();
  const chanel = searchParams.get('chanel');
  const dispatch = useAppDispatch();
  const { currentTheme } = useThemes();
  const location = useLocation();
  // const chanel = new URLSearchParams(location.search).get('chanel') || ''
  const [rewardSetting, setRewardSetting] = useState<RewardSettingResponse>();
  const streamerId = searchParams.get('streamerId');
  const [timeRemaining, setTimeRemaining] = useState(0);
  const [streamLink, setStreamLink] = useState('');
  const onShowChangePasswordPage = () => {
    if (isUserLoggedIn) setIsShowChangePasswordForm(true);
  };

  const getStreamLink = useCallback(async () => {
    setIsLoading(true);
    if (chanel) {
      const { ok, body, error } = await streamApi.getStreams();
      setIsLoading(false);
      if (ok && body) {
        setStreamChanels(body);
      }
      if (error) {
        setStreamChanels(null);
      }
    }
  }, [chanel]);

  const getRewardSetting = useCallback(async () => {
    if (isUserLoggedIn) {
      const { ok, body } = await streamApi.getRewardSetting();

      if (ok && body) {
        setRewardSetting(body);
        setTimeRemaining(body.timeToReward * SECOND_ON_MINUTE);
      }
    }
  }, [isUserLoggedIn, currentUser]);

  const getStreamer = async () => {
    if (streamerId) {
      const { ok, body } = await streamApi.getStreamerById(streamerId);
      if (ok && body) {
        setStreamLink(body.chanelLink);
      }
    }
  };

  useEffect(() => {
    getStreamer();
  }, [streamerId]);

  // useEffect(() => {
  //   getStreamLink();
  // }, [getStreamLink]);

  useEffect(() => {
    getRewardSetting();
  }, [getRewardSetting]);

  const closeForm = (): void => {
    dispatch(onChangeAuthPage(-1));
    dispatch(setShowSubMenu(false));
    setIsShowChangePasswordForm(false);
  };

  const handleOnClickChanel = (chanelName: string) => {
    setSearchParams({ chanel: chanelName });
    if (rewardSetting?.timeToReward)
      setTimeRemaining(SECOND_ON_MINUTE * rewardSetting?.timeToReward);
  };

  const handleClaim = async () => {
    if (timeRemaining <= 0) {
      const { ok } = await streamApi.reward();
      if (ok) {
        showSuccessModal({
          title: t('staking.success.claim-title'),
          content: t('promotion.success.message', {
            amount: rewardSetting?.value,
            type: '$TBET',
          }),
          onOk: () => {
            getRewardSetting();
          },
        });
      }
    }
  };

  const renderYotube = () => {
    // const youtubeLink =
    //   streamChanels &&
    //   streamChanels.find((str) => str.socialName.toLowerCase() === 'youtube')?.chanelLink;

    // if (youtubeLink === '' || !youtubeLink) {
    //   return (
    //     <div className="stream-player coming-soon">
    //       <span className="primary-text-color">COMING SOON</span>
    //     </div>
    //   );
    // }
    if (streamLink === '' || !streamLink) {
      return (
        <div className="stream-player coming-soon">
          <span className="primary-text-color">COMING SOON</span>
        </div>
      );
    }
    return (
      <div className="stream-player">
        <iframe
          src={`https://www.youtube.com/embed/${streamLink.replace(
            YOUTUBE_URL,
            '',
          )}?rel=0&modestbranding=1&mute=1&autohide=1&showinfo=0&controls=1&autoplay=1`}
          title="Terabet Live"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
          width={'100%'}
          height={'100%'}
        />
      </div>
    );
  };

  const renderTwitch = () => {
    // const twitchLink =
    //   streamChanels &&
    //   streamChanels.find((str) => str.socialName.toLowerCase() === 'twitch')?.chanelLink;

    // if (twitchLink === '' || !twitchLink) {
    //   return (
    //     <div className="stream-player coming-soon">
    //       <span className="primary-text-color">COMING SOON</span>
    //     </div>
    //   );
    // }
    if (streamLink === '' || !streamLink) {
      return (
        <div className="stream-player coming-soon">
          <span className="primary-text-color">COMING SOON</span>
        </div>
      );
    }
    return (
      <div className="stream-player">
        <TwitchPlayer
          channel={streamLink.replace(TWITCH_URL, '')}
          parent={['codesandbox.io', 'csb.app']}
          autoplay
          muted={true}
          allowFullscreen
          width={'100%'}
          height={'100%'}
        />
      </div>
    );
  };

  const renderTiktok = () => {
    // const tiktokLink =
    //   streamChanels &&
    //   streamChanels.find((str) => str.socialName.toLowerCase() === 'tiktok')?.chanelLink;

    if (streamLink === '' || !streamLink) {
      return (
        <div className="stream-player coming-soon">
          <span className="primary-text-color">COMING SOON</span>
        </div>
      );
    }
    window.open(streamLink, '_blank');
    return (
      <div className="stream-player">
        <img src={tiktok_bg} alt={IMG_ALT} width={'100%'} height={'100%'} />
      </div>
    );
  };

  useEffect(() => {
    let timerInterval: NodeJS.Timeout;

    if (isUserLoggedIn && rewardSetting?.active) {
      timerInterval = setInterval(() => {
        setTimeRemaining((prevTime) => {
          if (prevTime <= 0) {
            clearInterval(timerInterval);
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);
    }

    return () => {
      clearInterval(timerInterval);
    };
  }, [timeRemaining, isUserLoggedIn, rewardSetting]);

  const hours = Math.floor(timeRemaining / 3600);
  const minutes = Math.floor((timeRemaining % 3600) / 60);
  const seconds = timeRemaining % 60;

  // const renderPlayer = useMemo(() => {
  //   if (chanel === 'youtube') {
  //     return renderYotube();
  //   }
  //   if (chanel === 'twitch') {
  //     return renderTwitch();
  //   }
  //   if (chanel === 'tiktok') {
  //     return renderTiktok();
  //   }
  // }, [streamChanels?.length, chanel]);
  const renderPlayer = useMemo(() => {
    if (chanel?.toLocaleLowerCase() === 'youtube') {
      return renderYotube();
    }
    if (chanel?.toLocaleLowerCase() === 'twitch') {
      return renderTwitch();
    }
    if (chanel?.toLocaleLowerCase() === 'tiktok') {
      return renderTiktok();
    }
  }, [streamLink, chanel]);
  return (
    <div className="casino-page relative">
      <div className={`body-waraper`}>
        <Header isShowAllStreaming onShowChangePasswordPage={onShowChangePasswordPage} />

        <div className="streaming-container">
          {/* {!isLoading && streamChanels ? (
            <div className="iframe-container">{renderPlayer}</div>
          ) : (
            <div className="stream-player loader">
              <span className="spiner-loader"></span>
            </div>
          )} */}

          {!isLoading && streamLink ? (
            <div className="iframe-container">{renderPlayer}</div>
          ) : (
            <div className="stream-player loader">
              <span className="spiner-loader"></span>
            </div>
          )}
          {/* <div className="streaming-btn-container">
            <button
              disabled={chanel === 'youtube'}
              className={`streaming-btn youtube ${chanel === 'youtube' ? 'active' : ''} `}
              onClick={() => handleOnClickChanel('youtube')}
            >
              <YoutubeIcon height={30} isDarkMode={currentTheme === 'dark'} />
              <p>Youtube</p>
            </button>
            <button
              disabled={chanel === 'twitch'}
              className={`streaming-btn twitch ${chanel === 'twitch' ? 'active' : ''} `}
              onClick={() => handleOnClickChanel('twitch')}
            >
              <TwitchIcon height={30} isDarkMode={currentTheme === 'dark'} />
              <p>Twitch</p>
            </button>
            <button
              disabled={chanel === 'tiktok'}
              className={`streaming-btn tiktok ${chanel === 'tiktok' ? 'active' : ''} `}
              onClick={() => handleOnClickChanel('tiktok')}
            >
              <TiktokIcon height={30} isDarkMode={currentTheme === 'dark'} />
              <p>TikTok</p>
            </button>
          </div> */}
          {(chanel === 'twitch' || chanel === 'youtube') &&
            rewardSetting &&
            rewardSetting.active &&
            isUserLoggedIn && (
              <div className="streaming-btn-container">
                <button
                  disabled={timeRemaining > 0}
                  className={`streaming-btn claim-button ${timeRemaining > 0 ? 'active' : ''} `}
                  onClick={handleClaim}
                >
                  {timeRemaining > 0 ? (
                    <p>
                      {hours >= 1 ? (hours < 10 ? `0${hours}:` : `${hours}:`) : ''}
                      {minutes < 10 ? `0${minutes}` : minutes}:
                      {seconds < 10 ? `0${seconds}` : seconds}
                    </p>
                  ) : (
                    <p>{t('staking.form.claim')}</p>
                  )}
                </button>
              </div>
            )}
        </div>

        <FooterMenu
          isUserLogin={isUserLoggedIn}
          onShowChangePasswordPage={onShowChangePasswordPage}
          isShowAllStreaming
        />
      </div>
      <ChangePasswordPage isShow={isShowChangePasswordForm} closePage={closeForm} />
      <AuthPage />
      <TransactionModal />
    </div>
  );
};

export default Streaming;
